<div id="ct-info-heading" class="modal-header no-border">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<img class="menubar-logo-x h-home-logo" src="/style/logo/1" width="270">
</div>
<div class="modal-body js-above-spinner">
	{{#if details}}
			<div class="panel panel-border panel-{{details.color}}">
				<div class="panel-heading">
					{{#if details.title}}<h3 class="panel-title">{{details.title}}</h3>{{/if}}
				</div>
				<div class="panel-body">
					{{{details.details}}}
				</div>
				<div class="panel-footer">
					{{#if footer}}<span>{{{footer}}}</span>{{/if}}
					&nbsp;
					<div id="js-go-back" class="btn btn-xs btn-white pull-right">{{TR "Zurück"}}</div>
				</div>
			</div>
	{{else}}
		{{#each infos}}
			<div class="panel panel-border panel-{{color}}">
				<div class="panel-heading">
					{{#if title}}<h3 class="panel-title">{{title}}</h3>{{/if}}
				</div>
				<div class="panel-body">
					{{{summary}}}
				</div>
				<div class="panel-footer">
					{{#if footer}}<span>{{{footer}}}</span>{{/if}}
					{{#if details}}
						&nbsp;
						<div id="js-details-{{id}}" class="btn btn-xs btn-white pull-right js-show-details">{{TR "Details anzeigen"}}</div>
					{{/if}}
				</div>
			</div>
		{{/each}}
	{{/if}}
</div>
<div class="modal-footer">
	<button id="js-close" class="btn btn-primary">{{TR "OK"}}</button>
</div>
